export const selectIf = (bool) => (bool ? 'selected' : '');

export const checkIf = (bool) => (bool ? 'checked' : '');

export const disableIf = (bool) => (bool ? 'disabled' : '');
